<template>
    <div v-if="!loadingFilter" class="supplier-list animate__animated animate__fadeIn">
        <div v-for="supplier in suppliers" :key="supplier.uuid" class="supplier-card col s3 offset-s0">
            <div>
                <div class="container-image">
                    <img
                        v-if="supplier.logoImage && supplier.logoImage.fullPath"
                        :src="validateImg(supplier)"
                        class="logo"
                        @click="openCard(supplier.uuid)"
                    />
                    <div class="title-logo" @click="openCard(supplier.uuid)" v-else>
                        {{ setLogo(supplier.tradingName) }}
                    </div>
                </div>
                <div class="division">
                    <div class="line"></div>
                </div>
                <div class="info-container">
                    <div>
                        <a @click="openCard(supplier.uuid)" class="title"
                            >{{ truncateString(supplier.tradingName, 40) }}
                            <span
                                v-if="supplier.subscriptionVerified"
                                v-tippy="tippyOptions"
                                title="Fornecedor Verificado"
                                class="material-icons"
                            >
                                verified
                            </span>
                        </a>
                        <div class="info">
                            <i class="fas fa-map-marker-alt"></i>
                            {{ supplier.city }}, {{ supplier.state }}
                        </div>
                        <div class="info">
                            <i class="fas fa-tag"></i>
                            {{ truncateString(supplier.tagNames, 80).replaceAll('|', ' | ') || 'tag' }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-btn">
                <eg-button uppercase variant="eg-blue-outline" @click="openCard(supplier.uuid)" class="view-supplier-profile">
                    Visualizar perfil
                </eg-button>
                <div @click="!disabled ? $emit('push-supplier', supplier) : $emit('filter-first')">
                    <ButtonCheckbox class="quoatation-action-btn" :checked="supplierSelected(supplier.uuid)" :disabled="disabled">
                        {{ supplierSelected(supplier.uuid) ? 'Selecionado' : 'Adicionar na Cotação' }} 
                    </ButtonCheckbox>
                </div>
            </div>
        </div>
        <div class="supplier-not-found" v-show="!suppliers.length">
            <div>Nenhum Fornecedor encontrado</div>
        </div>
    </div>
    <div v-else>
        <div class="center-element loading-page">
            <eg-loading :size="70" />
            <div>Carregando...</div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import ButtonCheckbox from '../../../components/custom/button-checkbox.vue';
export default {
    props: {
        suppliers: Array,
        suppliersSelected: Array,
        loadingFilter: Boolean,
        disabled: Boolean
    },
    components: {
        ButtonCheckbox
    },
    name: 'NetworkSuppliersCard',
    data() {
        return {
            tippyOptions: {
                arrow: false,
                placement: 'top'
            }
        };
    },
    methods: {
        supplierSelected(id) {
            return !!this.suppliersSelected.find(({ uuid }) => uuid == id);
        },
        ...mapActions('supplierNetwork', ['clearSuppliers']),
        openCard(id) {
            this.clearSuppliers();
            const query = this.$route.query;
            this.$router.push({ name: 'ProfileNetworkSupplier', params: { id }, query });
        },
        validateImg(supplier) {
            if (supplier.logoImage && supplier.logoImage.fullPath) {
                return supplier.logoImage.fullPath;
            } else {
                return '';
            }
        },
        setLogo(tradingName) {
            const firtsName = tradingName
                .split(' ')[0]
                .substr(0, 1)
                .toUpperCase();
            let secondName = tradingName.split(' ')[1];
            if (!secondName) {
                secondName = tradingName
                    .split(' ')[0]
                    .substr(1, 1)
                    .toUpperCase();
            } else {
                secondName = secondName.substr(0, 1).toUpperCase();
            }
            return firtsName + secondName;
        },
        truncateString(str, num) {
            if (str.length <= num) {
                return str;
            }
            return str.slice(0, num) + '...';
        }
    }
};
</script>

<style lang="scss" scoped>
.content-list {
    display: flex;
    justify-content: flex-start;
}
.loading-page {
    display: flex;
    height: 85vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.supplier-not-found {
    display: flex;
    justify-content: center;
    width: 100%;
}
.loading-page .preloader-wrapper {
    margin-bottom: 12px;
}
.loading-page .preloader-wrapper .spinner-layer {
    border-color: var(--color--dark-blue);
}
.supplier-card {
    height: auto;
    background: #fff;
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: none !important;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
.supplier-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
}
.supplier-card .logo {
    max-width: 100%;
    width: auto;
    height: 180px;
    cursor: pointer;
    object-fit: contain;
}
.supplier-card .container-image {
    display: flex;
    justify-content: center;
    margin: 16px;
}
.supplier-card .division {
    display: flex;
    justify-content: center;
}
.supplier-card .division .line {
    border-bottom: #dbdbdb 1px solid;
    width: 100%;
}
.supplier-card .info-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px 16px 8px 16px;
}
.supplier-card .container-btn {
    display: flex;
    justify-content: center;
    padding: 0 16px 16px;
    gap: 8px;
    flex-direction: column;
}
.supplier-card .info-container .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    color: #0e53a5;
    margin-bottom: 10px;
    display: inline-block;
}
.supplier-card .info-container .title span {
    font-size: 16px;
    line-height: 16px;
    position: relative;
    bottom: -2px;
    color: #68ce6c;
}
.supplier-card .info-container .info {
    font-size: 13px;
    line-height: 1.4rem;
    /* identical to box height, or 123% */
    color: #707070;
    margin-bottom: 6px;
}
.quoatation-action-btn,
.view-supplier-profile {
    width: 100%;
    padding: 6px 9px;
    font-size: 12px;
}
.title-logo {
    font-weight: 600;
    font-size: 84px;
    line-height: 180px;
    cursor: pointer;
    color: #0e53a5;
}
@media screen and (max-width: 1800px) {
    .supplier-list {
        grid-template-columns: repeat(4, 1fr);
    }
}
@media screen and (max-width: 1505px) {
    .quoatation-action-btn {
        font-size: 13px;
    }
    .supplier-list {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media screen and (max-width: 1220px) {
    .quoatation-action-btn {
        font-size: 12px;
    }
    .supplier-list {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media screen and (max-width: 1025px) {
    .supplier-list {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media screen and (max-width: 840px) {
    .supplier-card {
        width: 100%;
        margin-left: 0px;
    }
    .quoatation-action-btn {
        font-size: 16px;
    }
    .supplier-list {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media screen and (max-width: 600px) {
    .supplier-list {
        grid-template-columns: 1fr;
    }
}
</style>
